//import {USERLIST} from '../actions';
import {findIndex} from 'lodash';

let namespace = 'controlProductOrder_';

const initialState = {  
	  data:[],
	  dataLoading: true,
	  dataFetchProps: {order:[['id','desc']],distinct:true,include:[{model:'pay',as:'m_orderpay',distinct:true,
						attributes:['id','pay_time','result','pay_type','total_pay_amount','loan_no','repay_amount','repay_date','remain_loan_amount']},
						{model:'client',as:'m_orderclient',attributes:['cust_name']},
			            {model:'repay',as:'m_orderRepay',attributes:['id','order_no','loan_no','loan_amount','loan_date','repay_amount','repay_date','remain_loan_amount','repay_notice_res']},
		  ]},
      modalVisible: false,
	  modalType: 'create',
	  orderDetailVisible: false,
	  orderRepayDetailVisible: false,
	  pwdModalVisible: false,
	  selectedRow: {},  
	  clickRow:{},
	  selectedRowIndex: -1,  
	  selectedRows: [],  
      selectedRowKeys: [],	  
	  pagination: {
		  showSizeChanger: true,
		  showQuickJumper: true,
		  showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
		  pageSizeOptions: ['5','10', '20', '40', '100'],
		  defaultPageSize: 5,
		  pageSize:5,
		  current: 1,		 
		},
	   searchProps:{},
	  
	  
}

export default function(state=initialState, action) {
  switch (action.type) {
    case namespace+"forcedUpdate": {		
	
      return {
        ...state,
        ...action.payload
      }
    }
	case namespace+"updateDataById": {
		
		let newData = state.data
		
		let {selectedRowIndex, id} = action.payload		
		
		newData[selectedRowIndex] = action.payload.data		
		
		return {...state, selectedRow: action.payload.data, data: newData}
	}
	


	case namespace+"deleteDataById": {
		
		let newData = state.data
		let {selectedRowIndex, id} = action.payload
		let i = selectedRowIndex ? selectedRowIndex : findIndex(newData, {id: id})
		newData.splice(i,1)
		
		return {...state, data: newData}
	}
	
	case namespace+"addOneRowData": {
		
		return {...state, data: [action.payload.data, ...state.data]}
	}
	
    default:
      return state;
  }
}